import VehicleEditorDialog from "./Dialogs/VehicleEditorDialog/VehicleEditorDialog";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import React, { CSSProperties } from "react";
import { useDialog } from "../providers/DialogProvider";
import { useDispatch } from "react-redux";
import { ApplicationDispatch } from "../store/application/types";
import { updateAmsVehicleAsync } from "../Data/VehicleData";
import { Tooltip } from "@mui/material";
import {Organization} from "@amsanalytics/react-shared-library/build/Models/Organization";
import {Vehicle} from "@amsanalytics/react-shared-library";

interface VehicleEditIconComponentProps {
  disabled?: boolean;
  vehicleOnApp: Vehicle | undefined;
  vehicleToEdit: Vehicle | undefined;
  organizations: Organization[];
  applicationId?: string;
  isIndirectApplication: boolean;
  canEditMilage?: boolean; // whether the user can edit the vehicle's mileage
  canEditFullVehicle?: boolean; // whether the user can edit the vehicle's full details
  style?: CSSProperties;
  onVehicleSaved?: (vehicle: Vehicle) => void; // after the vehicle saved
}

export default function VehicleEditIconComponent(props: VehicleEditIconComponentProps) {
  const [openDialog, closeDialog] = useDialog();
  const dispatch = useDispatch<ApplicationDispatch>();

  // Update AMS vehicle record and our DB Vehicle entity.
  const updateVehicle = async (vehicle: Vehicle) => {
    try {
      if (props.applicationId) {
        const saved = await updateAmsVehicleAsync(dispatch, vehicle, props.applicationId, props.isIndirectApplication);
        if (saved) {
          props.onVehicleSaved?.(vehicle);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Tooltip title="Edit Vehicle">
      <IconButton
        size="small"
        disabled={!props.vehicleToEdit || props.disabled}
        style={props.style}
        onClick={() => {
          openDialog({
            children: (
              <VehicleEditorDialog
                vehicle={props.vehicleToEdit!}
                canEditInventory={props.canEditMilage}
                canEditFullVehicle={props.canEditFullVehicle}
                onClose={closeDialog}
                onSaveVehicle={(vehicle: Vehicle) => {
                  updateVehicle(vehicle);
                  closeDialog();
                }}
              />
            )
          });
        }}>
        <EditIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
